import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="radio-select"
export default class extends Controller {
  static targets = ["element", "radio"];

  connect() {
    this.radioTargets.forEach((element) => {
      if (element.checked) {
        element
          .closest("li")
          .classList.remove(
            "border-gray-200",
            "dark:border-slate-700",
            "dark:bg-slate-800",
          );

        element
          .closest("li")
          .classList.add(
            "border-primary-500",
            "dark:border-primary-700",
            "dark:bg-primary-500/10",
            "bg-primary-500/10",
          );
      }
    });
  }

  select(event) {
    this.elementTargets.forEach((element) => {
      element.classList.remove(
        "border-primary-500",
        "dark:border-primary-700",
        "dark:bg-primary-500/10",
        "bg-primary-500/10",
      );
      element.classList.add(
        "border-gray-200",
        "dark:border-slate-700",
        "dark:bg-slate-800",
      );
    });

    event.currentTarget
      .closest("li")
      .classList.remove(
        "border-gray-200",
        "dark:border-slate-700",
        "dark:bg-slate-800",
      );

    event.currentTarget
      .closest("li")
      .classList.add(
        "border-primary-500",
        "dark:border-primary-700",
        "dark:bg-primary-500/10",
        "bg-primary-500/10",
      );
  }
}
